<div class="loader">
  <div class="bar bar_1"></div>
  <div class="bar bar_2"></div>
  <div class="bar bar_3"></div>
</div>
